const getRedirect = ({
  pathname,
  search,
}: {
  pathname: string;
  search: string;
}) => ({ pathname, search })

export default getRedirect
